import { Cloud, CloudOff, FlaskConical, LoaderCircle, Radio } from 'lucide-react';
import type { ConnectionState } from '../types';

const labels: Record<ConnectionState, string> = {
  connected: 'Подключено',
  connecting: 'Подключение…',
  reconnecting: 'Восстановление…',
  disconnected: 'Нет соединения',
  demo: 'Демо-данные',
};

export function ConnectionBadge({ state, compact = false }: { state: ConnectionState; compact?: boolean }) {
  const Icon =
    state === 'connected'
      ? Radio
      : state === 'demo'
        ? FlaskConical
        : state === 'disconnected'
          ? CloudOff
          : state === 'connecting' || state === 'reconnecting'
            ? LoaderCircle
            : Cloud;
  return (
    <span
      className={`connection-badge connection-badge--${state} ${compact ? 'connection-badge--compact' : ''}`}
      aria-live="polite"
    >
      <Icon className={state === 'connecting' || state === 'reconnecting' ? 'spin' : ''} size={15} aria-hidden="true" />
      {!compact && <span>{labels[state]}</span>}
      {compact && <span className="sr-only">{labels[state]}</span>}
    </span>
  );
}
